import React, { JSX } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUserStore } from "../../store/userStore";

export default function RequireAuthenticated({ children }: { children: JSX.Element }) {
  const user = useUserStore((s) => s.user);
  const accessToken = useUserStore((s) => s.accessToken);
  const location = useLocation();

  if (!user || !accessToken) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
}
